import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';

export default {
  namespaced: true,
  state: {
    is_logging_in: false,
    is_registering: false,
    is_subscribing: false,
    error_login: null,
    error_register: null,
    error_subscribe: null,
    user: null
  },
  mutations: {
    error_login(state, payload) {
      state.error_login = payload;
    },
    error_register(state, payload) {
      state.error_register = payload;
    },
    logging_in(state, payload) {
      state.is_logging_in = payload;
    },
    registering(state, payload) {
      state.is_registering = payload;
    },
    set_user(state, payload) {
      state.user = payload;
    },
    is_subscribing(state, payload) {
      state.is_subscribing = payload;
    },
    error_subscribe(state, payload) {
      state.error_subscribe = payload;
    }
  },
  actions: {
    register({commit}, payload) {
      commit('registering', true);
      const registration_info = payload;
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
      .then(() => {
          const user = firebase.auth().currentUser;

          // Set the full name
          user.updateProfile({
            displayName: `${registration_info.firstname} ${registration_info.lastname}`,            
          }).then(function() {
            // Update successful.
          }).catch(function() {
            // An error happened.
          });
          commit('registering', false);
      })
      .catch(error => {
        commit('error_register', error);
        commit('registering', false);
      });
      // user.sendEmailVerification().then(function() {
      //   // Email sent.
      // }).catch(function(error) {
      //   // An error happened.
      // });
    },
    login({commit}, payload) {
      // Show loading
      commit('logging_in', true);
      // Attempt Firebase sign-in
      firebase.auth().signInWithEmailAndPassword(payload.username, payload.password)
      .then(() => { 
        // Succeeded so set user and clear loading and errors
        //commit('set_user', fbUser); // TODO: Clean this up so that it's not the entire object
        commit('error_login', null);
        commit('logging_in', false);
      })
      .catch((error) => { 
        // Failed so show error and disable loading
        commit('error_login', error)
        commit('logging_in', false);
      });
    },
    logout({commit}) {
      // Attempt Firebase sign-out
      firebase.auth().signOut()
      .then(() => { 
        commit('set_user', null);
      })
      .catch(() => { 
        // Failed so show error and disable loading
      });
    },
    subscribe({commit}, payload) {
      commit('is_subscribing', true);
      firebase.analytics().logEvent('generate_lead', { value: 'Subscribed' });
      var subscribeLead = firebase.functions().httpsCallable('subscribeLead');
      subscribeLead(payload)
      .then(() => {
        localStorage.setItem('subscribed', true);      
        commit('error_subscribe', null);
        commit('is_subscribing', false);
      })
      .catch(error => {
        commit('error_subscribe', error);
        commit('is_subscribing', false);
      })
    }
  },
  getters: {
    // NOTE: Apparently getters are not getters/setter style and should be used for filtering only.
    //        Access properties directly from code instead.
    error_login(state) {
      return state.error_login;
    },
    error_register(state) {
      return state.error_register;
    },
    error_subscribe(state) {
      return state.error_subscribe;
    },
    is_logging_in(state) {
      return state.is_logging_in
    },
    is_registering(state) {
      return state.is_registering
    },
    user(state) {
      return state.user;
    },
    is_subscribing(state) {
      return state.is_subscribing;
    }
  }
}

export const types = {
  mutations: {
    // commit
    ERROR_LOGIN: 'User/error_login',
    ERROR_REGISTER: 'User/error_register',
    ERROR_SUBSCRIBE: 'User/error_subscribe',
    LOGGING_IN: 'User/logging_in',
    SET_USER: 'User/set_user'
  },
  actions: {
    // dispatch
    REGISTER_NEW_USER: 'User/register',
    LOGIN: 'User/login',
    LOGOUT: 'User/logout',
    SUBSCRIBE_LEAD: 'User/subscribe'
  },
  getters: {
    ERROR_LOGIN: 'User/error_login',
    ERROR_REGISTER: 'User/error_register',
    ERROR_SUBSCRIBE: 'User/error_subscribe',
    IS_LOGGING_IN: 'User/is_logging_in',
    IS_REGISTERING: 'User/is_registering',
    IS_SUBSCRIBING: 'User/is_subscribing',
    USER: 'User/user'
  }
}